<template>
  <div>
    <el-tabs v-model="type">
      <el-tab-pane label="沟通记录" name="1">
        <!-- <div style="max-height: 300px; overflow: auto"> -->
        <record-item
          v-for="item in recordList"
          :key="item.created"
          :record-info="item"
        />
        <!-- </div> -->
        <pagination
          :total-count="queryForm.total"
          :page.sync="queryForm.pageNo"
          :limit.sync="queryForm.pageSize"
          @pagination="getOrderProcess"
        />
      </el-tab-pane>
      <el-tab-pane label="转接记录" name="2">
        <template v-if="recordList && recordList.length > 0">
          <!-- <div style="max-height: 300px; overflow: auto"> -->
          <record-item
            v-for="item in recordList"
            :key="item.created"
            :record-info="item"
          />
          <!-- </div> -->
          <pagination
            :total-count="queryForm.total"
            :page.sync="queryForm.pageNo"
            :limit.sync="queryForm.pageSize"
            @pagination="getOrderTransfer"
          />
        </template>
        <el-empty v-else description="暂无记录" image-size="50"></el-empty>
      </el-tab-pane>
      <el-tab-pane v-if="workOrder.flowId" label="审批记录" name="3">
        <template v-if="taskList && taskList.length > 0">
          <!-- <div style="max-height: 300px; overflow: auto"> -->
          <el-timeline class="task-timeline">
            <el-timeline-item
              v-for="(item, index) in taskList"
              :key="index"
              :timestamp="item.approveTime"
              placement="top"
              :color="
                item.status === 'PASS'
                  ? '#67C23A'
                  : item.status === 'FAIL'
                  ? '#F56C6C'
                  : '#409EFF'
              "
              :icon="
                item.status === 'PASS'
                  ? 'el-icon-check'
                  : item.status === 'FAIL'
                  ? 'el-icon-close'
                  : 'el-icon-time'
              "
            >
              <el-card>
                <h4>{{ item.approveName }}</h4>
                <p>{{ item.taskName }}</p>
                <p v-if="item.remark">审核意见: {{ item.remark }}</p>
                <div
                  v-if="item.appendixInfos && item.appendixInfos.length > 0"
                  style="margin-top: 20px"
                >
                  <div class="img-block">
                    <el-image
                      v-for="(item, index) in item.appendixInfos.filter(
                        (x) => x.attachmentType == 'IMAGE'
                      )"
                      :key="index"
                      style="width: 100px; height: 100px; margin-right: 10px"
                      :src="item.appendisUrl"
                      :preview-src-list="[item.appendisUrl]"
                      fit="fill"
                    ></el-image>
                  </div>
                  <div
                    v-for="file in item.appendixInfos.filter(
                      (x) => x.attachmentType == 'FILE'
                    )"
                  >
                    <span>附件：</span>
                    <span
                      @click="downloadFile(file.appendisUrl, file.appendisName)"
                      class="c-pointer"
                      style="margin-right: 5px; color: rgb(96, 98, 102)"
                      ><i class="el-icon-document"></i>
                      {{ file.appendisName }}</span
                    >
                    <span
                      @click="downloadFile(file.appendisUrl, file.appendisName)"
                      class="c-pointer color-blue"
                      >点击下载</span
                    >
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
          <!-- </div> -->
        </template>
        <el-empty v-else description="暂无记录" image-size="50"></el-empty>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import api from "plus/api";
import pagination from "components/pagination";
import recordItem from "components/workOrderDetail/recordItem";

export default {
  name: "workOrderProcess",
  components: { pagination, recordItem },
  props: {
    workOrder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      type: "1",
      recordList: [],
      queryForm: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      taskList: [],
    };
  },
  watch: {
    type: {
      handler: function (newValue) {
        this.queryForm.pageNo = 1;
        if (newValue == "1") {
          this.getOrderProcess();
        } else if (newValue == "2") {
          this.getOrderTransfer();
        } else if (this.type == "3") {
          this.getOrderTask();
        }
      },
      immediate: true,
    },
    workOrder: {
      handler: function (val) {
        if (this.type == "1") {
          this.getOrderProcess();
        } else if (this.type == "2") {
          this.getOrderTransfer();
        } else if (this.type == "3") {
          this.getOrderTask();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 沟通记录
    async getOrderProcess() {
      this.recordList = [];
      if (!this.$route.query.wkOrderId) {
        return;
      }
      const response = await api.workmanage.getManageWkOrderProList({
        ...this.queryForm,
        wkOrderId: this.$route.query.wkOrderId,
      });
      this.recordList = response.data.data;
      this.queryForm.total = response.data.totalCount;
    },
    // 转接记录
    async getOrderTransfer() {
      this.recordList = [];
      if (!this.$route.query.wkOrderId) {
        return;
      }
      const response = await api.workmanage.getManageWkOrderTransferList({
        ...this.queryForm,
        wkOrderId: this.$route.query.wkOrderId,
      });
      this.recordList = response.data.data;
      this.queryForm.total = response.data.totalCount;
    },
    // 审批记录
    async getOrderTask() {
      this.recordList = [];
      if (!this.workOrder.flowId) {
        return;
      }
      const response = await api.workmanage.getWkOrderTaskList(
        this.workOrder.flowId
      );
      this.taskList = response.data.data;
    },
    saveAs(data, name) {
      var urlObject = window.URL || window.webkitURL || window;
      var export_blob = new Blob([data]);
      var save_link = document.createElement("a");
      save_link.href = urlObject.createObjectURL(export_blob);
      save_link.download = name;
      save_link.click();
    },
    downloadFile(url, name) {
      let fileUrl = url;
      const fileName = name;

      fileUrl = fileUrl.replace(/\\/g, "/");
      const xhr = new XMLHttpRequest();
      xhr.open("GET", fileUrl, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName);
        }
      };
      xhr.send();

      // if (fileUrl.endsWith(".pdf")) {
      //   window.open(fileUrl);
      // } else if (fileUrl.endsWith(".txt")) {
      //   fileUrl = fileUrl.replace(/\\/g, "/");
      //   const xhr = new XMLHttpRequest();
      //   xhr.open("GET", fileUrl, true);
      //   xhr.responseType = "blob";
      //   xhr.onload = () => {
      //     if (xhr.status === 200) {
      //       // 获取文件blob数据并保存
      //       this.saveAs(xhr.response, fileName);
      //     }
      //   };
      //   xhr.send();
      // } else {
      //   const eleLink = document.createElement("a");
      //   eleLink.download = fileName;
      //   eleLink.style.display = "none";
      //   eleLink.href = fileUrl;

      //   eleLink.click();
      //   document.body.removeChild(eleLink);
      // }
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.task-timeline {
  /deep/ .card__body {
    padding: 0 !important;
  }
}
.img-block {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
